var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"base-button",attrs:{"icon":"ion checkmark-outline","unelevated":"","color":"tes-gradient-blue","label":"تایید تراکنش","size":"lg"},on:{"click":_vm.paidDialogShow}})}
var staticRenderFns = []

export { render, staticRenderFns }